export default __webpack_public_path__ + "static/media/unselectedBarChartIcon.6f1cbe0b.svg";